import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { addAction } from '@/redux/store/information';
import '@/pages/containers/auth/scss/form.scss';
import '../scss/index.scss';

class EditIntroduce extends React.Component <any, any>  {
	constructor(props: any) {
		super(props);
		this.state = {
			presentation: '',
			textareaLength: 0

		}
	}

	public componentDidMount() {
		if(this.props.presentation) {
			this.setState({
				presentation: this.props.presentation,
				textareaLength: this.props.presentation.length
			})
		}
	}

	public render() {
		return (
			<div className="gray-bg page-editIntroduce">
				<div className="textarea-box">
					<textarea  placeholder="请输入店铺介绍" maxLength={140} value={this.state.presentation } onChange={(e: any) => this.changeState('presentation', e.target.value)}></textarea>
					<p className="text-total">{this.state.textareaLength}/140</p>
				</div>
				<div className="default-btn-warrper">
					<button className="default-btn" onClick={() => this.submitForm()}>确定</button>
				</div>
			</div>
		)
	}

	private changeState(k: string, v: any) {
		this.setState({
			[k]: v,
			textareaLength: v.length
		})
	}
	// 更新state
	private changeInfoState(k:string, v:any) {
		(this.props as any).addAction({
			[k]: v
		})
	}

	private submitForm() {

		this.changeInfoState('presentation', this.state.presentation);
		this.goForm();
	}

	private goForm() {
		(this.props as any).history.goBack(-1)
	}
}

const mapStateToProps = ( state: any ) => {
    return {
        ...state.storeInformationReducer
    };
};

const mapDispatchToProps = ( dispatch: Dispatch ) => {
    return bindActionCreators({addAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(EditIntroduce);